(ns app.front.ui.transitions
  (:require ["react-transition-group/esm/CSSTransition" :default CSSTransition]))


(defn transition
  "Transitions children with the animation given in `:transition` prop. Shows when `:in` is truthy,
   hides when it is falsy. `:timeout` must match the transition time in CSS. Supported transitions
   are listed in `_transitions.scss`."
  [{:keys [in timeout transition unmount-on-exit]} & children]
  [:> CSSTransition {:in              in
                     :timeout         timeout
                     :classNames      transition
                     :unmount-on-exit (not (false? unmount-on-exit))}
   (-> :<>
       (cons children)
       vec)])


(defn fade-out-up
  "Fades (and unmounts) children up and out when the `in` prop is falsy."
  [{:keys [in]} & children]
  (into [transition
         {:in         in
          :timeout    500
          :transition "fade-out-up"}]
        children))
